import { PaginationComponent } from './_globle/pagination/pagination.component';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule , HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthCheck } from './auth/auth.check';
import { MyInterceptor } from './my-interceptor';
import { LocationStrategy, HashLocationStrategy} from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule  } from './app-routing.module';
import {DashboardModule} from './dashboard/dashboard.module';
import { AngularMaterialModule } from './angular-material.module';
import { TestModule } from './test/test.module';
import { ConfirmationDialogComponent } from './test/test-step/confirmation-dialog/confirmation-dialog.component';
import { StepFormComponent } from './test/test-step/step-form/step-form.component';
import { EllipsisDirective } from './ellipsis.directive';
import { DataModule } from './data/data.module';
import { ProjectModule } from './project/project.module';
import { SharedModule } from './shared/shared.module';
import { SettingModule } from './setting/setting.module';
import { ReportModule } from './report/report.module';
import { LoginModule } from './login/login.module';
import { UrlService } from './_services/url.service';
import { LayoutModule } from './layout/layout.module';
import { NoSpacesDirective } from './no-spaces.directive';
import { WorkflowModule } from './workflow/workflow.module';
import { BrowserSessionService } from './browser-session.service';
import { UserService } from './_services/user.service';
// import { WorkFlowSearchPipe } from './work-flow-search.pipe';
import { APP_INITIALIZER } from '@angular/core';
import { initUiRedirectFactory } from './ui-redirect.initializer';

// import { FileSaverModule } from 'ngx-filesaver';
// const appRoutes: Routes = [
//         {path : '', component : UserLoginComponent},
//           {path : 'userregister', component: UserRegisterComponent},
//         {path : 'BeatBlipSubscriptionUI', component : AppComponent},
//         {path : 'login', component : UserLoginComponent},
//         {path : 'dashboard', component : UserDashboardComponent, canActivate : [AuthCheck]}
// ];

@NgModule({
    imports: [
        // RouterModule.forRoot(
        //   appRoutes, {enableTracing: true}// For Debugging
        // ),
        AppRoutingModule,
        LoginModule,
        DashboardModule,
        SharedModule,
        TestModule,
        DataModule,
        FormsModule,
        ProjectModule,
        SettingModule,
        ReportModule,
        AngularMaterialModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LayoutModule,
        WorkflowModule
    ],
    declarations: [
        AppComponent,
        PaginationComponent,
        EllipsisDirective,
        NoSpacesDirective,
        // WorkFlowSearchPipe
    ],
    providers: [ UserService,
    { provide: APP_INITIALIZER, useFactory: initUiRedirectFactory, deps: [UserService], multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MyInterceptor,
            multi: true
        },
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        AuthCheck, UrlService, CookieService
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
